import { getPageLinkByNodeId, LinkModel, useGetLinks } from "@nishtech/Store/Nishtech/NishtechLinksSelectors";
import NishtechLink from "@nishtech/Widgets/Basic/NishtechLink";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

const enum fields {
    className = "className",
    links = "links",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.links]: LinkModel[];
        [fields.className]: string;
    };
    extendedStyles?: LinkListStyles;
}

export interface LinkListStyles {
    linkListWrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    linkWrapper?: InjectableCss;
}

export const linkListStyles: LinkListStyles = {
};

const defaultCustomCss = `.list-wrapper {
}

.title-wrapper {
}

.list-title {
}

.links-wrapper {
}

.list-link {
}
`;

export const NishtechHeaderAdditionalMenu: FC<OwnProps> = ({ fields, extendedStyles }) => {
    const links = useGetLinks(fields.links, o => o.fields.destination);
    const styles = useMergeStyles("linkList", linkListStyles, extendedStyles);
    return (
        <ul className={fields.className}>
            {links.map((link, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={index}>
                    {link.url && (
                        <>
                            {fields.links[index].fields.titlePrefix ? `${fields.links[index].fields.titlePrefix} ` : ''}
                            <a
                                href={link.url}
                                target={fields.links[index].fields.openInNewWindow ? "_blank" : ""} rel="noreferrer"
                            >
                                {fields.links[index].fields.overriddenTitle || link.title}
                            </a>
                        </>
                    )}
                </li>
            ))}
        </ul>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const widgetModule: WidgetModule = {
    component: NishtechHeaderAdditionalMenu,
    definition: {
        group: "Basic",
        icon: "ax-link-list",
        fieldDefinitions: [
            {
                name: fields.links,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    const {
                        destination: { type, value },
                        overriddenTitle,
                    } = item.fields;
                    if (overriddenTitle) {
                        return overriddenTitle;
                    }
                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return link?.title;
                    }
                    if (type === "Category") {
                        let displayValue = "";
                        const categories = (state as any).pageEditor.categories;
                        if (!categories) {
                            displayValue = "Loading...";
                        } else {
                            const matchingCategories = categories.filter((o: { id: string }) => o.id === value);
                            if (matchingCategories.length === 0) {
                                displayValue = "Unknown";
                            } else {
                                displayValue = matchingCategories[0].shortDescription;
                            }
                        }

                        return displayValue;
                    }
                    if (type === "Url") {
                        return value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        isRequired: true,
                    },
                    {
                        name: "overriddenTitle",
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "openInNewWindow",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                ],
                tab: basicTab,
            },
            {
                name: fields.className,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            }
        ],
    },
};

export default widgetModule;
